import { Component } from "react"
import PropTypes from "prop-types"
import { IconButton } from "@mui/material"
import { Save } from "@mui/icons-material"

import "./style.scss"

class TokenNameInput extends Component {
  static propTypes = {
    onCancel: PropTypes.func.isRequired,
    renameTokenHandler: PropTypes.func.isRequired,
    initialValue: PropTypes.string.isRequired,
  }

  constructor(props) {
    super(props)

    this.state = {
      value: props.initialValue,
    }
  }

  save = () => {
    const { value } = this.state
    const { initialValue, onCancel, renameTokenHandler } = this.props

    if (value === initialValue || value === "") {
      onCancel()
    } else {
      renameTokenHandler(value)
    }
  }

  onKeyPress = ev => {
    if (ev.which === 13 || ev.keyCode === 13) {
      this.save()
    }
  }

  onChange = ev => {
    this.setState({ value: ev.target.value })
  }

  render() {
    const { initialValue } = this.props
    const { value } = this.state

    return <div className="token-name-input">
      <input
        type="text"
        placeholder={initialValue}
        value={value}
        onChange={this.onChange}
        onKeyPress={this.onKeyPress}
        autoFocus
      />
      <IconButton color="primary" onClick={this.save} size="large">
        <Save />
      </IconButton>
    </div>
  }
}

export default TokenNameInput
